import { Feature } from "@/types";
import { OnboardingFeature } from "./OnboardingFeature";

interface OnboardingFeatureListProps {
    features: Feature[]
};

export const OnboardingFeatureList : React.FC<OnboardingFeatureListProps> = ({features}) => {
    return (
        <div className="row row-cols-3 g-3">
            {features.map(feature => <div className="col-4" key={feature.title}>
                <OnboardingFeature feature={feature}/>
            </div>)}
        </div>
    );
}